import axios from "axios"
import Swal from "sweetalert2";

document.querySelector('#pgoGasRequest') && new Vue({
    el: '#pgoGasRequest',
    methods: {
        async cancel() {
            const res = await Swal.fire({
                title: 'Cancel Request?',
                text: "Are you sure you want to cancel this request?",
                icon: 'warning',
                showCancelButton: true,
                // confirmButtonColor: '#3085d6',
                confirmButtonColor: '#d33',
                // cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                reverseButtons: true,
            });


            if (res.isConfirmed) {

                try {
                    await axios.post(`/office/gas-slips/${requestId}/cancel`);

                    Swal.fire(
                        'Success!',
                        'Request cancelled',
                        'success'
                    );

                    window.location.href = '/office/gas-slips';

                } catch (e) {
                    Swal.fire(
                        'Deleted!',
                        e.toString(),
                        'error'
                    );

                }

            }

        },
        print() {
            $('#gasSlipModal').modal('show');
        },
        printImage() {
            var prtContent = document.getElementById("gasSlipImg");
            var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            WinPrint.document.write(prtContent.innerHTML);
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
        },
        download() {
            var link = document.createElement('a');
            link.href = `/office/gas-slips/${requestId}/print`;
            link.download = gasSlipNo + '.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
});